// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_xterm_css_xterm_css-node_modules_xterm-addon-fit_lib_xterm-addon-fit_js--56a045","src_styles_css-src_wasm-terminal_ts"], () => (__webpack_require__("./src/index.ts")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
